import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { useState } from "react";

export const CategoryData = (props) => {

  const { t } = useTranslation();
  let [search, setSearch] = useState("")
  let localDate = new Date().toDateString()
  let createdAt = new Date().getFullYear() +'-'+ ( new Date().getMonth() + 1)  + '-' + new Date().getDay()  
   
  return (

      <div className="sidebar border_article">
        <div className="sidebar-item search-form">
          <h3 className="sidebar-title">{ t("categorie.rechercher")}</h3>
          <form action="" className="mt-3">
            <input type="text" onChange={ (val) => setSearch(val.target.value) } />
              <a href={search.length > 2 ? `/articles/search/${search}` : "#"}>
            <button type="button">
                <i className="bi bi-search text-white"></i>
            </button>
              </a>
          </form>
        </div>

        <div className="sidebar-item categories">
          <h3 className="sidebar-title">{ t("categorie.categories")}</h3>
          <ul className="mt-3">
            {props.categories.filter( dat => dat.parentId == null ).map((category) => {
              return (
                <>
                  <li key={ category.id}>
                    <a href={"/categories/"+ category.id} style={{ borderBottom : '1px solid red'}}>
                      <b>{category.name} <span>({ category.countArticle})</span></b>
                    </a>
                  </li>
                  {
                    (category.id == process.env.REACT_APP_ID_INFOROMATION) && (
                      props.categories.filter( dat => dat.parentId == process.env.REACT_APP_ID_INFOROMATION ).map((category) => {
                        return (
                          <>
                            <li key={ category.id} style={{ marginLeft : 20}}>
                              <a href={"/categories/"+ category.id}>
                                <b><i className={ category.icone } style={{ color : 'red'}}></i> { category.name} <span>({ category.countArticle})</span></b>
                              </a>
                            </li>
                          </>
                        );
                      })
                    )
                  }
                </>
              );
            })}
          </ul>
        </div>

        <div className="sidebar-item recent-posts">
          <h3 className="sidebar-title">{ t("categorie.recent")}</h3>

          <div className="mt-3 pt-3">
            {
              props.articles.map((article, index) => {
                  localDate = new Date(article.createdAt).toDateString()
                  createdAt = new Date(article.createdAt).getFullYear() +'-'+ ( new Date(article.createdAt).getMonth() + 1)  + '-' + new Date(article.createdAt).getDay()  
                  return(
                    <div className="post-item  overflow-hidden" key={ article.id }>
                      <a href={"/articles/" + article.id}><img src={ article.images[0] ? article.images[0].image : article.images.image } alt={ article.images[0] ? article.images[0].image : article.images.image } title={ article.title } /></a>
                      <div>
                        <h4 className="text-truncate" title={ article.title }>
                          <a href={"/articles/" + article.id}>
                            { article.title }
                          </a>
                        </h4>
                        <time style={{  fontSize : 12, color :"blue" }}><i className={article?.category.icone}></i> <a href={"/articles/" + article.id}>{ article.category.name }</a></time>
                        <time dateTime={ createdAt } style={{ fontSize : 11 }}>{ localDate }</time>
                      </div>
                    </div>
                )
              })
            }
            
          </div>
        </div>

        <div className="sidebar-item tags d-none">
          <h3 className="sidebar-title">{ t("categorie.motcle")}</h3>
          <ul className="mt-3">
            {
              props.categories.filter( dat => dat.parentId != null ).map((category) => {
                return (
                  <li key={ category.id }> <a href={"/categories/"+ category.id} >{ category.name }</a> </li>
                );
              })
            }
          </ul>
        </div>
      </div>
      
  );
};
